/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { LangleyCopyrightBar } from "components/footer/copyright-bar";
import { LangleyMainFooter } from "components/footer/main-footer";
import { CookieConsent } from "components/footer/consent";
import { useSimpliCity } from "cms/hooks/use-simplicity";

const Footer = () => {
    const { settings } = useSimpliCity();
    const showCookieConsent = settings?.feature_show_cookie_consent === "true";
    return (
        <div className='langley-footer'>
            <LangleyMainFooter />
            <LangleyCopyrightBar />
            {showCookieConsent && <CookieConsent />}
        </div>
    );
};

export { Footer };
